import { render, staticRenderFns } from "./vernotificaciones.vue?vue&type=template&id=40aa3c43&"
import script from "./vernotificaciones.vue?vue&type=script&lang=js&"
export * from "./vernotificaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports